import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import constants from "../common/constants";

import { GET_NEWS } from "./actions.type";
import {formatDate} from "../common/formatting";

const NEWS_SITE_URL = process.env.VUE_APP_NEWS_SITE_URL || '';

function decodeHtmlEntities(value) {
  if (typeof value !== 'string' || !value.includes('&')) {
    return value || '';
  }

  if (typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  return value
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

function resolveNewsLink(link) {
  if (!link || typeof link !== 'string') {
    return '';
  }

  const trimmed = link.trim();
  if (!trimmed) {
    return '';
  }

  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (/^\/\//.test(trimmed)) {
    if (typeof window !== 'undefined' && window.location && window.location.protocol) {
      return `${window.location.protocol}${trimmed}`;
    }
    return `https:${trimmed}`;
  }

  const fallbackBase = NEWS_SITE_URL || (
    typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : ''
  );

  if (!fallbackBase) {
    return trimmed;
  }

  try {
    return new URL(trimmed, fallbackBase).toString();
  } catch (e) {
    return trimmed;
  }
}


const NewsModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    news: [],
    loading: false
  },
  mutations:{
    setNewsLoading(state, isLoading) {
      state.loading = !!isLoading;
    },
    storeNews(state,data){
      // Transform API data to match table format (title, category, date)
      // API returns: title, teaser, category, date, link
      if (!data || !Array.isArray(data)) {
        state.news = [];
        return;
      }
      state.news = data.map((post) => {
        const titleText = post.title || '';
        const teaserText = post.teaser || '';
        const titleWithTeaser = teaserText
          ? `<strong>${titleText}</strong><br><span style="font-size: 0.9em; color: #666; font-weight: normal;">${teaserText}</span>`
          : titleText;
        const resolvedLink = resolveNewsLink(post.link);
        
        return {
          title: { 
            value: titleWithTeaser,
            link: resolvedLink,
            isHtml: !!teaserText
          },
          category: { value: decodeHtmlEntities(post.category || '') },
          date: { value: post.date ? formatDate(post.date, constants.DD_MM_YYYY) : '' },
          teaser: post.teaser || '',
          link: resolvedLink
        };
      });
    }
  },
  getters: {

  },
  actions: {
    async [GET_NEWS](context,payload){
      let res = {};
      context.commit('setNewsLoading', true);
      const category = (payload && payload.category) ? payload.category : '';
      const limit = (payload && payload.limit) ? payload.limit : '';
      const baseUrl = ((ApiService.defaults && ApiService.defaults.baseURL) || '').replace(/\/+$/, '');
      const newsPath = baseUrl.endsWith('/api') ? '/v1/news' : '/api/v1/news';
      const queryParts = [];
      if (category) {
        queryParts.push('category=' + encodeURIComponent(category));
      }
      if (limit) {
        queryParts.push('limit=' + encodeURIComponent(limit));
      }
      const query = queryParts.length ? ('?' + queryParts.join('&')) : '';
      await ApiService.get(newsPath + query).then(response => {
        res = response.data;
        context.commit('storeNews', res.data || []);
      }).catch(error => {
        res = error;
        // Set empty array on error to prevent undefined issues
        context.commit('storeNews', []);
      }).finally(() => {
        context.commit('setNewsLoading', false);
      });
      return res;
    }
  },
};

export default NewsModule;
